import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { GetChargesByRelatedDriverResponse } from "@qivia/schemas-ev-charging";
import { RootState } from "../../redux/store";
import { QueryStatus, axiosInstanceWithPhoneToken } from "../../utils";

export interface ChargesState {
  chargesStatus: QueryStatus;
  charges: GetChargesByRelatedDriverResponse;
}

const initialState: ChargesState = {
  chargesStatus: "idle",
  charges: [],
};

export const getDriverChargesAsync = createAsyncThunk(
  "getDriverCharges/call/",
  async (payload: { companyUuid: string }) => {
    const phoneToken = localStorage.getItem("phoneToken");
    if (!phoneToken) {
      throw Error();
    }
    const axios = axiosInstanceWithPhoneToken(phoneToken);
    const response = await axios.get<GetChargesByRelatedDriverResponse>(
      `/driver_access/driver/charges`,
      { params: payload },
    );
    return response.data;
  },
);

export const chargesSlice = createSlice({
  name: "charges",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDriverChargesAsync.pending, (state) => {
        state.chargesStatus = "processing";
      })
      .addCase(getDriverChargesAsync.fulfilled, (state, action) => {
        state.charges = action.payload;
        state.chargesStatus = "success";
      })
      .addCase(getDriverChargesAsync.rejected, (state) => {
        state.chargesStatus = "failed";
      });
  },
});

export const selectCharges = (state: RootState) => state.charges.charges;
export const selectChargesStatus = (state: RootState) =>
  state.charges.chargesStatus;

export default chargesSlice.reducer;
